var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["columns", "onClick", "component"];
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableSpread, "_nonIterableSpread");
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
__name(_iterableToArray, "_iterableToArray");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
__name(_arrayWithHoles, "_arrayWithHoles");
import React, { useCallback, useEffect, useState, useRef } from "react";
import { MenuVerticalItem } from "./Item";
import { menuVerticalCls } from "./Menu.less";
function MenuVertical(_ref) {
  var items = _ref.items, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? false : _ref$multiple, _ref$resetState = _ref.resetState, resetState = _ref$resetState === void 0 ? false : _ref$resetState, _ref$handleOverlay = _ref.handleOverlay, handleOverlay = _ref$handleOverlay === void 0 ? null : _ref$handleOverlay;
  var menuRef = useRef(null);
  var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), openedItems = _useState2[0], setOpenItems = _useState2[1];
  var scrollToSubmenu = /* @__PURE__ */ __name(function scrollToSubmenu2(e) {
    return function() {
      if (!e || !menuRef || menuRef && !menuRef.current) {
        return;
      }
      var submenuBoundingProps = e.target.getBoundingClientRect();
      var menuBoundingProps = menuRef.current.getBoundingClientRect();
      var top = submenuBoundingProps.top + menuRef.current.scrollTop - menuBoundingProps.top;
      menuRef.current.scrollTop = top;
    };
  }, "scrollToSubmenu");
  var handleLinkClick = useCallback(function() {
    if (typeof handleOverlay === "function") {
      handleOverlay(false);
    }
  }, [handleOverlay]);
  var handleOpen = useCallback(function(index) {
    return function(e, itemData) {
      if (itemData.hasItems) {
        e.preventDefault();
      } else {
        handleLinkClick();
      }
      setTimeout(scrollToSubmenu(e), 1);
      if (openedItems.indexOf(index) > -1) {
        setOpenItems(openedItems.filter(function(item) {
          return item !== index;
        }));
      } else {
        setOpenItems(multiple ? [].concat(_toConsumableArray(openedItems), [index]) : [index]);
      }
    };
  }, [multiple, openedItems, handleLinkClick]);
  var isOpened = useCallback(function(index) {
    return openedItems.indexOf(index) > -1;
  }, [openedItems]);
  useEffect(function() {
    if (resetState) {
      if (menuRef && menuRef.current) {
        menuRef.current.scrollTop = 0;
      }
      setOpenItems([]);
    }
  }, [resetState]);
  return /* @__PURE__ */ React.createElement("ul", {
    className: menuVerticalCls,
    ref: menuRef
  }, items.map(function(_ref2, index) {
    var columns = _ref2.columns, onClick = _ref2.onClick, component = _ref2.component, linkProps = _objectWithoutProperties(_ref2, _excluded);
    return /* @__PURE__ */ React.createElement(MenuVerticalItem, {
      onLinkClick: handleLinkClick,
      opened: isOpened(index),
      linkProps,
      items: columns,
      key: index,
      component,
      onClick: handleOpen(index)
    });
  }));
}
__name(MenuVertical, "MenuVertical");
export {
  MenuVertical
};
